document.addEventListener('keydown', function(e) {
  const items = document.querySelectorAll('.ProductGallery__NavigationItem');
  const current = document.activeElement;
  const currentIndex = Array.from(items).indexOf(current);
  
  if (currentIndex === -1) return;
  
  let nextIndex;
  
  switch(e.key) {
    case 'ArrowRight':
    case 'ArrowDown':
      e.preventDefault();
      nextIndex = (currentIndex + 1) % items.length;
      items[nextIndex].focus();
      break;
      
    case 'ArrowLeft':
    case 'ArrowUp':
      e.preventDefault();
      nextIndex = (currentIndex - 1 + items.length) % items.length;
      items[nextIndex].focus();
      break;
      
    case 'Enter':
    case ' ':
      e.preventDefault();
      current.click();
      break;
  }
});

document.addEventListener('keydown', function(e) {
  const swatches = document.querySelectorAll('.swatch-circle');
  const current = document.activeElement;
  const currentIndex = Array.from(swatches).indexOf(current);
  
  if (currentIndex === -1 || !current.classList.contains('swatch-circle')) return;
  
  let nextIndex;
  
  switch(e.key) {
    case 'ArrowRight':
    case 'ArrowDown':
      e.preventDefault();
      nextIndex = (currentIndex + 1) % swatches.length;
      swatches[nextIndex].focus();
      break;
      
    case 'ArrowLeft':
    case 'ArrowUp':
      e.preventDefault();
      nextIndex = (currentIndex - 1 + swatches.length) % swatches.length;
      items[nextIndex].focus();
      break;
      
    case 'Enter':
    case ' ':
      e.preventDefault();
      if (!current.classList.contains('unavailable')) {
        current.click();
      }
      break;
  }
});